import { render } from "./ContactUs.vue?vue&type=template&id=7994e388&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./contactus.scss?vue&type=style&index=0&id=7994e388&lang=scss&scoped=true"

import exportComponent from "/Users/mac/lavide-pro2/lavideo-pages/noka/lwInno.com /node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7994e388"]])

export default __exports__